module.exports = __webpack_public_path__ + "static/media/ServiceNow_Step1a_Image15.405a35aa.jpg";